angular.module('modals')
    .controller('ChangeEmailModalController', ['$scope', '$q', '$uibModalInstance', '$uibModal', 'Logger', 'Alert', 'ModalHandler', 'ProviderInvitation', 'Registration', 'user',
        function($scope, $q, $uibModalInstance, $uibModal, Logger, Alert, ModalHandler, ProviderInvitation, Registration, user) {
            $scope.user_id = user.id;
            $scope.oldEmail = user.email;
            $scope.newEmail = '';

            $scope.checkEmail = function (email) {
                if (!email) {
                    return $q.reject();
                }
    
                var d = $q.defer();
                
                ProviderInvitation.validate({email: email}, function(success) {
                    $scope.form.newEmail.$setValidity('email', true);
                    $scope.alerts = [];
                    d.resolve();
                }, function (failure) {
                    $scope.form.newEmail.$setValidity('email', false);
                    $scope.alerts = [];
                    Alert.error($scope.alerts, 'user.exists', true);
                    d.reject();
                });
                
                return d.promise;
            };

            $scope.submit = function () {
                Logger.log('Requesting email change: ' + $scope.newEmail);
                Registration.requestEmailChange({
                    user_id: $scope.user_id,
                    email: $scope.newEmail
                }).$promise
                    .then(function() {
                        ModalHandler.dismiss($uibModalInstance);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/change_email_request_confirmation.html',
                            controller: 'ChangeEmailRequestConfirmationController',
                            resolve: {
                                newEmail: function() {
                                    return $scope.newEmail;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                                Logger.log('Confirmation dialog dismissed');
                            })
                            .catch(function () {
                                Logger.log('Confirmation dialog cancelled');
                            });                        
                    })
                    .catch(function(response) {
                        if(response.status === 422) {
                            $state.go('error_page', {error_key: 'confirmation_token.invalid'}); // change to notification?
                        }
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ChangeEmailRequestConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'newEmail',
        function($scope, $uibModalInstance, ModalHandler, newEmail) {
            $scope.newEmail = newEmail;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ResetPasswordModalController', ['$scope', '$uibModalInstance', '$uibModal', 'Logger', 'ModalHandler', 'Notification', 'Password', 'user',
        function($scope, $uibModalInstance, $uibModal, Logger, ModalHandler, Notification, Password, user) {
            $scope.email = user.email;

            $scope.submit = function () {
                Logger.log('Requesting password change for: ' + $scope.email);
                
                Password.reset({'user': {'email': $scope.email}}).$promise
                    .then(function() {
                        ModalHandler.dismiss($uibModalInstance);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/reset_password_request_confirmation.html',
                            controller: 'ResetPasswordConfirmationController',
                            resolve: {
                                email: function() {
                                    return $scope.email;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                                Logger.log('Confirmation dialog dismissed');
                            })
                            .catch(function () {
                                Logger.log('Confirmation dialog cancelled');
                            });                        
                    })
                    .catch(function(response) {
                        Notification.error('Error: {{response.error}}');
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('ResetPasswordConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'email',
        function($scope, $uibModalInstance, ModalHandler, email) {
            $scope.email = email;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('CreateLoginModalController', ['$scope', '$uibModalInstance', '$uibModal', 'Logger', 'ModalHandler', 'Notification', 'User', 'user',
        function($scope, $uibModalInstance, $uibModal, Logger, ModalHandler, Notification, User, user) {
            $scope.email = "";

            $scope.submit = function () {
                Logger.log('Requesting create login for user: ' + $scope.email);
                
                User.sendPasswordInvitation({ id: user.id }, { email: $scope.email}).$promise
                    .then(function() {
                        $uibModalInstance.close($scope.email);

                        // show dialog confirming that request was submitted
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/user/create_login_request_confirmation.html',
                            controller: 'CreateLoginConfirmationController',
                            resolve: {
                                email: function() {
                                    return $scope.email;
                                }
                            }
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result
                            .then(function () {
                            })
                            .catch(function () {
                                Logger.log('Confirmation dialog dismissed');
                            });                        
                    })
                    .catch(function(response) {
                        Notification.error('Error: {{response.error}}');
                    });
            };

            $scope.discard = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ])
    .controller('CreateLoginConfirmationController', ['$scope', '$uibModalInstance', 'ModalHandler', 'email',
        function($scope, $uibModalInstance, ModalHandler, email) {
            $scope.email = email;
            
            $scope.close = function() {
                ModalHandler.dismiss($uibModalInstance);
            };
        }
    ]);
